import React, { PureComponent } from 'react';

import ExperimentSwitcher from './ExperimentSwitcher';

import {
  closedContainer,
  container,
  icon,
  openContainer,
  titleHeader,
} from './styles.module.css';

/**
 * Development Helper
 */
export default class DevHelper extends PureComponent {
  state = {
    isOpen: false,
  };

  handleClick = (event) => {
    event.preventDefault();
    this.setState({ isOpen: !this.state.isOpen });
  };

  render() {
    if (__DEVELOPMENT__ || LDT_ENV === 'staging') {
      return this.state.isOpen ? (
        <div className={container}>
          <div className={openContainer}>
            <span className={titleHeader} onClick={this.handleClick}>
              <img
                alt="experiments"
                className={icon}
                src="/icons/experiments.png"
              />
              <h2>Feature Flags</h2>
            </span>
            <ExperimentSwitcher {...this.props} />
          </div>
        </div>
      ) : (
        <div className={container}>
          <div className={closedContainer}>
            <img
              alt="experiments"
              className={icon}
              src="/icons/experiments.png"
              onClick={this.handleClick}
            />
          </div>
        </div>
      );
    }
    return <React.Fragment />;
  }
}
